/**
 * DOB limits by gender:
 * Male   → at least 21 years old
 * Female → at least 18 years old
 * Others → at least 18 years old
 */

export function getMinAgeForGender(gender) {
  const g = String(gender || '').toLowerCase();
  if (g === 'male') return 21;
  if (g === 'female') return 18;
  return 18;
}

function pad2(n) {
  return String(n).padStart(2, '0');
}

/** YYYY-MM-DD for "today minus N years" (exact calendar day). */
export function getMaxDobDate(minAgeYears) {
  const d = new Date();
  d.setFullYear(d.getFullYear() - minAgeYears);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

/** Oldest allowed DOB (default 60 years). */
export function getMinDobDate(maxAgeYears = 60) {
  const d = new Date();
  d.setFullYear(d.getFullYear() - maxAgeYears);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function getDobLimitsForGender(gender) {
  const minAge = getMinAgeForGender(gender);
  return {
    minAge,
    maxDOB: getMaxDobDate(minAge),
    minDOB: getMinDobDate(60),
  };
}

export function calculateAge(birthdate) {
  if (!birthdate) return 0;
  const today = new Date();
  const birth = new Date(birthdate);
  if (Number.isNaN(birth.getTime())) return 0;

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}

export function isDobValidForGender(dob, gender) {
  if (!dob) return false;
  const { minAge, maxDOB, minDOB } = getDobLimitsForGender(gender);
  if (dob > maxDOB || dob < minDOB) return false;
  return calculateAge(dob) >= minAge;
}
